const dark_theme = require('themes/dark.json');
const light_theme = require('themes/light.json');
const color_theme = require('themes/color.json');
const map_themes = {
    dark:dark_theme,
    light:light_theme,
    color:color_theme
}
let map;
// initialise le bloc google map
async function initGoogleMapBlock(){
    const  mapData = await wp.apiFetch({path:"/cdm-map/map_data/"}).then(json=>json); //Données viennent du endpoint savé dans functions.php du block
    container = document.querySelector("#cdm-map");
    if(!container || ! window.google){
        console.error('Google map codems block: check if container exists or if google map is enqueued. (is the "GOOGLE_MAP_API" constant defined in wp-config?)')
        return;
    };
    if(!window.google.maps){
        console.error('Google map codems block: check if container exists or if google map is enqueued. (is the "GOOGLE_MAP_API" constant defined in wp-config?)')
        return;
    };
    const theme = map_themes[container.getAttribute('data-theme')];

    const mapOptions = {
        zoom: 12,
        scrollwheel : false,
        zoomControl: true,
        disableDefaultUI: true,
        iconColor:container.getAttribute('data-icon-color'),
        // center: markerPos, //TODO
        center: new google.maps.LatLng(mapData.main_address.lat,mapData.main_address.lng),
        labelContent: mapData.site_name, //TODO
        mapTypeControlOptions: {
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, theme.id]
        },
        mapTypeId: theme.id
    }

    map = new google.maps.Map(container, mapOptions);
    map.mapTypes.set(theme.id,  new google.maps.StyledMapType(theme.theme, {name:theme.id}));
    const bounds = new google.maps.LatLngBounds();

    cdmMapAddMarker(map,bounds,mapData.main_address,mapData.site_logo)
}

function cdmMapAddMarker(map,bounds,acf_adress,logo = "",icon = null){
    const defaultIcon = {
            path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
            fillColor: map.iconColor,
            fillOpacity: 1,
            strokeWeight: 0,
            rotation: 0,
            scale: 0.1,
            anchor: new google.maps.Point(150, 500),
    }

    const marker = new google .maps.Marker({
        position: new google.maps.LatLng(acf_adress.lat, acf_adress.lng),
        map: map,
        icon: icon?icon:defaultIcon,
    });

    const infoWindow = new google.maps.InfoWindow({
        content: `  <div class="content-infopup-wrapper">
                        ${logo}
                        <a data-direction="${acf_adress.address}" href="https://www.google.ca/maps/dir/${encodeURIComponent(acf_adress.address)}" target="_blank" rel="nooponer">${acf_adress.address}</a>
                        <a data-direction="${acf_adress.address}" href="https://www.google.ca/maps/dir/${encodeURIComponent(acf_adress.address)}" target="_blank" rel="nooponer">${__('Directions')}</a>
                    </div>`
    });

    marker.addListener('click', function() {
        infoWindow.open(map, marker);
    });

    bounds.extend(new google.maps.LatLng(acf_adress.lat, acf_adress.lng));

    container.classList.remove('loading')
}

cdm_blocks.fn.ready(()=>{
    if(!wp.blockEditor){
        initGoogleMapBlock();
    }
});